// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentStatus__root--qjp5 {
    padding: 16px;
    max-width: 550px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 6px;
    border: 1px solid transparent;
}

    .PaymentStatus__root--qjp5.PaymentStatus__processing--dxCp {
        border-color: var(--warning-color);
        margin-bottom: 24px;
    }

    .PaymentStatus__root--qjp5.PaymentStatus__successful--QaF5 {
        border-color: var(--success-color);
    }

    .PaymentStatus__root--qjp5.PaymentStatus__failed--fJaz {
        border-color: var(--error-color);
        margin-bottom: 24px;
    }

    @media screen and (min-width: 1024px) {.PaymentStatus__root--qjp5 {
        padding: 32px
}
    }

.PaymentStatus__noticeItems--sNc1 {
    max-width: 550px;
    margin: 0 auto;
    display: flex;
    gap: 16px;
}

@media screen and (max-width: 1023px) {

.PaymentStatus__noticeItems--sNc1 {
        flex-direction: column
}
    }

@media screen and (min-width: 1024px) {

.PaymentStatus__noticeItems--sNc1 {
        align-items: center;
        gap: 20px
}
    }

.PaymentStatus__statusIconWrapper--gjRP {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
}

.PaymentStatus__statusIconWrapper--gjRP.PaymentStatus__processing--dxCp {
        background-color: var(--main-color);
    }

.PaymentStatus__statusIconWrapper--gjRP.PaymentStatus__successful--QaF5 {
        background-color: var(--success-color);
    }

.PaymentStatus__statusIconWrapper--gjRP.PaymentStatus__failed--fJaz {
        background-color: var(--error-color);
    }

.PaymentStatus__statusIconWrapper--gjRP > img {
        width: 28px;
        height: 28px;
    }

.PaymentStatus__subtitle--wKwo {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: var(--secondary-color);
}

.PaymentStatus__title--X1HD {
    font-size: 34px;
    font-weight: 700;
    line-height: 44px;
    color: var(--secondary-color);
    margin-bottom: 8px;
    text-align: center;
}

.PaymentStatus__statusInformation--D0hG {
    margin-bottom: 24px;
    color: var(--secondary-color);
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
}

.PaymentStatus__statusInformation--D0hG.PaymentStatus__processing--dxCp {
        color: var(--warning-color);
    }

.PaymentStatus__statusInformation--D0hG.PaymentStatus__successful--QaF5 {
        color: var(--success-color);
    }

.PaymentStatus__statusInformation--D0hG.PaymentStatus__failed--fJaz {
        color: var(--error-color);
    }

.PaymentStatus__additionalInformation--nTkV {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    color: var(--secondary-color);
}

.PaymentStatus__additionalInformation--nTkV > strong {
        font-weight: 600;
    }

.PaymentStatus__additionalInformation--nTkV > a {
        text-decoration: underline;
        color: var(--secondary-color);
    }

.PaymentStatus__buttons--tFy9 {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin-top: 24px;
}

@media screen and (max-width: 1023px) {

.PaymentStatus__buttons--tFy9 {
        width: 100%;
        flex-direction: column
}

        .PaymentStatus__buttons--tFy9 > * {
            width: 100%;
        }
    }
`, "",{"version":3,"sources":["webpack://./src/ui/components/PaymentStatus/PaymentStatus.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;AAmBjC;;IAjBI;QACI,kCAAkC;QAClC,mBAAmB;IACvB;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,gCAAgC;QAChC,mBAAmB;IACvB;;IAEA,uCAxBJ;QAyBQ;AAER;IADI;;AAGJ;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,SAAS;AAUb;;AARI;;AANJ;QAOQ;AAOR;IANI;;AAEA;;AAVJ;QAWQ,mBAAmB;QACnB;AAER;IADI;;AAGJ;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AAkBvB;;AAhBI;QACI,mCAAmC;IACvC;;AAEA;QACI,sCAAsC;IAC1C;;AAEA;QACI,oCAAoC;IACxC;;AAEA;QACI,WAAW;QACX,YAAY;IAChB;;AAGJ;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AAarB;;AAXI;QACI,2BAA2B;IAC/B;;AAEA;QACI,2BAA2B;IAC/B;;AAEA;QACI,yBAAyB;IAC7B;;AAGJ;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;AAUjC;;AARI;QACI,gBAAgB;IACpB;;AAEA;QACI,0BAA0B;QAC1B,6BAA6B;IACjC;;AAGJ;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AAUpB;;AARI;;AAPJ;QAQQ,WAAW;QACX;AAMR;;QAJQ;YACI,WAAW;QACf;IACJ","sourcesContent":[".root {\n    padding: 16px;\n    max-width: 550px;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    border-radius: 6px;\n    border: 1px solid transparent;\n\n    &.processing {\n        border-color: var(--warning-color);\n        margin-bottom: 24px;\n    }\n\n    &.successful {\n        border-color: var(--success-color);\n    }\n\n    &.failed {\n        border-color: var(--error-color);\n        margin-bottom: 24px;\n    }\n\n    @media (--large) {\n        padding: 32px;\n    }\n}\n\n.noticeItems {\n    max-width: 550px;\n    margin: 0 auto;\n    display: flex;\n    gap: 16px;\n\n    @media (--mobile) {\n        flex-direction: column;\n    }\n\n    @media (--large) {\n        align-items: center;\n        gap: 20px;\n    }\n}\n\n.statusIconWrapper {\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 24px;\n\n    &.processing {\n        background-color: var(--main-color);\n    }\n\n    &.successful {\n        background-color: var(--success-color);\n    }\n\n    &.failed {\n        background-color: var(--error-color);\n    }\n\n    > img {\n        width: 28px;\n        height: 28px;\n    }\n}\n\n.subtitle {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    color: var(--secondary-color);\n}\n\n.title {\n    font-size: 34px;\n    font-weight: 700;\n    line-height: 44px;\n    color: var(--secondary-color);\n    margin-bottom: 8px;\n    text-align: center;\n}\n\n.statusInformation {\n    margin-bottom: 24px;\n    color: var(--secondary-color);\n    text-align: center;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 20px;\n\n    &.processing {\n        color: var(--warning-color);\n    }\n\n    &.successful {\n        color: var(--success-color);\n    }\n\n    &.failed {\n        color: var(--error-color);\n    }\n}\n\n.additionalInformation {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    text-align: center;\n    color: var(--secondary-color);\n\n    > strong {\n        font-weight: 600;\n    }\n\n    > a {\n        text-decoration: underline;\n        color: var(--secondary-color);\n    }\n}\n\n.buttons {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 16px;\n    margin-top: 24px;\n\n    @media (--mobile) {\n        width: 100%;\n        flex-direction: column;\n\n        > * {\n            width: 100%;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `PaymentStatus__root--qjp5`,
	"processing": `PaymentStatus__processing--dxCp`,
	"successful": `PaymentStatus__successful--QaF5`,
	"failed": `PaymentStatus__failed--fJaz`,
	"noticeItems": `PaymentStatus__noticeItems--sNc1`,
	"statusIconWrapper": `PaymentStatus__statusIconWrapper--gjRP`,
	"subtitle": `PaymentStatus__subtitle--wKwo`,
	"title": `PaymentStatus__title--X1HD`,
	"statusInformation": `PaymentStatus__statusInformation--D0hG`,
	"additionalInformation": `PaymentStatus__additionalInformation--nTkV`,
	"buttons": `PaymentStatus__buttons--tFy9`
};
export default ___CSS_LOADER_EXPORT___;
